import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/content";
import { BrandLogo } from "./Header";
import { NewsletterSignup } from "./NewsletterSignup";

export const Footer = () => (
  <footer className="bg-pine text-sage py-14" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1fr_1.1fr] gap-10 items-end">
      <div>
        <div className="inline-flex rounded-2xl bg-paper px-4 py-3">
          <BrandLogo className="h-24" />
        </div>
        <p className="mt-4 text-sm">
          A faith-based nonprofit ministry ·{" "}
          <a href={PHONE_TEL} className="underline underline-offset-4 decoration-brass-light" data-testid="footer-phone-link">{PHONE_DISPLAY}</a>
        </p>
      </div>
      <NewsletterSignup dark testId="footer-newsletter" />
    </div>
    <div className="max-w-6xl mx-auto px-6 mt-10 flex flex-wrap justify-between gap-4 text-sm text-mist/70">
      <a href="/resources" className="hover:text-sage" data-testid="footer-guides-link">Free guides</a>
      <a href="/admin" className="hover:text-sage" data-testid="footer-inbox-link">Team sign-in</a>
    </div>
  </footer>
);
